var _rect, _circle, _circle2, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantDefaultIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#008859"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#008859"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 127.5,
    stroke: "#121212",
    strokeOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 70.2222,
    y: 70.2222,
    width: 115.556,
    height: 115.556,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.96 118.51C162.703 113.073 158.243 108.785 152.801 108.74H148.169V100.329C148.282 93.048 144.462 86.2714 138.175 82.5981C131.887 78.9248 124.108 78.9248 117.821 82.5981C111.533 86.2714 107.713 93.048 107.826 100.329V108.74H103.204C97.7634 108.785 93.3048 113.071 93.0445 118.505L90.4445 165.237C90.2618 168.056 91.247 170.826 93.1687 172.896C95.0904 174.966 97.7793 176.154 100.604 176.181H155.416C158.24 176.154 160.929 174.966 162.851 172.896C164.772 170.826 165.758 168.056 165.575 165.237L162.96 118.51ZM115.053 100.329C114.925 95.619 117.364 91.211 121.423 88.8183C125.481 86.4256 130.519 86.4256 134.578 88.8183C138.636 91.211 141.076 95.619 140.947 100.329V108.74H115.053V100.329ZM155.416 168.965C156.207 168.958 156.96 168.628 157.5 168.05C158.108 167.402 158.419 166.53 158.358 165.643L155.743 118.91C155.695 117.303 154.404 116.011 152.796 115.964H148.165V119.517H140.942V115.964H115.048V119.517H107.826V115.964H103.209C101.601 116.011 100.31 117.303 100.262 118.91L97.6379 165.643C97.5778 166.53 97.8901 167.403 98.4998 168.05C99.0402 168.628 99.7937 168.958 100.585 168.965H155.416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantDefaultIcon);
export default __webpack_public_path__ + "static/media/merchant-default-icon.ed3f46ea2a05c69f5b73fc02e21176d2.svg";
export { ForwardRef as ReactComponent };